import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ClientInfoResponse, ConfirmacionBodyBitsoResponse, CotizacionCryptoBitsoRequest, CriptoActivoBitso } from './modelos/ClientBitsoInfo';

@Injectable({
  providedIn: 'root'
})
export class BitsoService {
  private apiUrl = `${environment.webApiUrl}api/Bitso`;

  constructor(private http: HttpClient) {}

  obtenerInfoCliente(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  obtenerInfoClienteModel(): Observable<ClientInfoResponse> {
    return this.http.get<ClientInfoResponse>(this.apiUrl);
  }

  obtenerCriptoActivosBitso(): Observable<CriptoActivoBitso[]> {
    return this.http.get<CriptoActivoBitso[]>(this.apiUrl+'/Balance');
  }

  obtenerCotizacion(cotizacionRequest: CotizacionCryptoBitsoRequest): Observable<CotizacionCryptoBitsoRequest> {
    return this.http.post<CotizacionCryptoBitsoRequest>(`${this.apiUrl}/ObtenerCotizacion`, cotizacionRequest);
  }

  confirmarCotizacion(cotizacionRequest: CotizacionCryptoBitsoRequest): Observable<ConfirmacionBodyBitsoResponse> {
    return this.http.post<ConfirmacionBodyBitsoResponse>(`${this.apiUrl}/ConfirmarCotizacion`, cotizacionRequest);
  }

}
